import React, { useMemo, useState, useEffect } from 'react';
import { AWARD_PRIZE_TYPE, DELIVER_STATUS, SHOW_STATUS_TYPE_ARRAY } from 'lib/constants/award';
import { BenefitRecordAwardStatus } from 'lib/constants/fragment';
import { shouldShowPrompt, markPromptShown } from 'lib/utils/util';

import './index.scss';

// 我的奖励--奖励tab页
const PrizeInfoCard = ({ prizeInfo, receiveAward }) => {
  const { prizePic, id, prizeName, prizeType, deliverStatus, recordStatus, fusionPrizeRecordId } = prizeInfo;
  const ID = id || fusionPrizeRecordId;
  const [hasClicked, setHasClicked] = useState(!shouldShowPrompt(`dotState-${ID}`));

  useEffect(() => {
    setHasClicked(!shouldShowPrompt(`dotState-${ID}`));
  }, [ID]);
  // 支持实物、q币、ams道具奖励展示已领取状态
  const hasReceived = useMemo(() => {
    if (
      SHOW_STATUS_TYPE_ARRAY.includes(prizeType) &&
      (deliverStatus === DELIVER_STATUS.DELIVERED || recordStatus === BenefitRecordAwardStatus.Delivered)
    ) {
      return true;
    }
    return false;
  }, [deliverStatus, prizeType, recordStatus]);

  const handleReceive = () => {
    // 非碎片奖励
    receiveAward(prizeInfo);
    setHasClicked(true);
    markPromptShown(`dotState-${ID}`);
  };

  return (
    <div className="lottery-info-card" onClick={handleReceive}>
      {!hasClicked && !hasReceived && prizeType !== AWARD_PRIZE_TYPE.NOTHING ? (
        <>
          <div className="lottery-info-card__synthesis" />
          <div className="lottery-info-card__pending">待领取</div>
        </>
      ) : null}
      <div className={'lottery-info-card__unopened unopned-flip'}>
        <div className={'lottery-info-card__unopened__image'} />
      </div>
      <div className="lottery-info-card__opened open-flip">
        <div className="lottery-info-card__opened__image-container">
          <img className="lottery-info-card__opened__image" src={prizePic} alt="[图片]" />
          {hasReceived ? <div className="lottery-info-card__opened__status">已发放</div> : null}
        </div>
        <div className="lottery-info-card__opened__text">{prizeName}</div>
      </div>
    </div>
  );
};

export default PrizeInfoCard;
